/**
 * Web mock for react-native-print
 */

export const print = async ({ html, filePath, url }) => {
  if (html) {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.focus();
      // Wait for resources to load if any
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  } else if (url || filePath) {
    window.open(url || filePath, '_blank');
  }
};

export const selectPrinter = async () => {
  console.warn('selectPrinter is not supported on web.');
  return null;
};

export default {
  print,
  selectPrinter,
};
